module.exports = __webpack_public_path__ + "img/linkedinIcon.d2f9a750.svg";